module.exports = __webpack_public_path__ + "static/media/zap.8cf4dc43.svg";